/* src/locations/api.js */

import gql from 'graphql-tag';

export const LOCATION_FRAGMENT = gql`
  fragment LocationFragment on Location {
    _id
    name
    address
    type
  }
`;

export const LOCATIONS_QUERY = gql`
  query getLocations($input: SearchLocationsInput!) {
    locationsAdmin(input: $input) {
      count
      locations {
        ...LocationFragment
      }
    }
  }
  ${LOCATION_FRAGMENT}
`;

export const ADD_LOCATION_MUTATION = gql`
  mutation addLocation($input: LocationInput!) {
    addLocation(input: $input) {
      ...LocationFragment
    }
  }
  ${LOCATION_FRAGMENT}
`;

export const ADD_LOCATION_TO_UNIVERSITY_MUTATION = gql`
  mutation addLocationToUniversity($university: ID!, $locationInput: LocationInput!) {
    addLocationToUniversity(_university: $university, input: $locationInput) {
      ...LocationFragment
    }
  }
  ${LOCATION_FRAGMENT}
`;

export const ADD_INTERVIEW_LOCATION_MUTATION = gql`
  mutation addInterviewLocation($organization: ID!, $locationInput: LocationInput!) {
    addInterviewLocation(_organization: $organization, input: $locationInput) {
      ...LocationFragment
    }
  }
  ${LOCATION_FRAGMENT}
`;

export const EDIT_LOCATION_MUTATION = gql`
  mutation editLocation($location: ID!, $updateLocationInput: UpdateLocationInput!) {
    editLocation(_location: $location, input: $updateLocationInput) {
      ...LocationFragment
    }
  }
  ${LOCATION_FRAGMENT}
`;

export const REMOVE_LOCATION_MUTATION = gql`
  mutation removeLocation($location: ID!) {
    removeLocation(_location: $location)
  }
`;



// WEBPACK FOOTER //
// ./src/modules/locations/api.js